import { FileParameter, ReadFileData } from '@lmt/shared-types';

export type MeasurementGlobalState = {
  measuredValues: MeasuredValue[];
  readFile?: ReadFileData;
  file?: FileParameter;
  pdfFile?: FileParameter | null;
};

export const defaultMeasurementState = (): MeasurementGlobalState => ({
  measuredValues: [],
  readFile: undefined,
  file: undefined,
  pdfFile: undefined,
});

export interface MeasuredValue {
  key: string;
  name: string;
  value: string;
  unit: string;
}
